<template>
  <div id='invisible'>
    <div class="body">
      <div v-if="weixinFlag" class="topmasker">
        <div class="box">
          <p class="head">下载中消在线APP :</p>
          <p class="detail">1. 点击右上角<i class="icon1"></i>按钮</p>
          <p class="detail">2. 选择<span><i class="icon2"></i>在浏览器中打开</span></p>
        </div>
      </div>
      <div class="toplogo"></div>
      <div class="topTitle">中消在线</div>
      <div class="toptext">应急消防服务平台</div>
      <div class="btn">
        <span class="text" @click="jump">立即下载</span>
      </div>
      <div class="iphone"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      weixinFlag: false
    }
  },
  methods: {
    // origin () {
    //   if (window.orientation === 180 || window.orientation === 0) { }
    //   if (window.orientation === 90 || window.orientation === -90) {
    //     document.getElementById('invisible').style.height = document.documentElement.clientHeight + 'px'
    //     document.getElementById('invisible').style.width = document.documentElement.clientWidth + 'px'
    //   }
    // },

    jump () {
      var ua = window.navigator.userAgent.toLowerCase()
      var browser = {
        versions: (function () {
          var u = navigator.userAgent

          // eslint-disable-next-line no-unused-vars
          var app = navigator.appVersion
          return {
            trident: u.indexOf('Trident') > -1, // IE
            presto: u.indexOf('Presto') > -1, // opera
            webKit: u.indexOf('AppleWebKit') > -1, //
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, //
            mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, // iPhone
            iPad: u.indexOf('iPad') > -1, // iPad
            webApp: u.indexOf('Safari') === -1 // web
          }
        }()),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
      }

      if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
        console.log('ios')
        window.location = 'https://itunes.apple.com/cn/app/id1301911560?mt=8'
      } else if (browser.versions.android) {
        console.log('android')
        // console.log(ua.match(/MicroMessenger/i))
        let matcher = ua.match(/MicroMessenger/i)
        console.log(matcher)
        if (matcher.indexOf('micromessenger') > -1) {
          this.weixinFlag = true
        } else {
          window.location = 'http://cdn.zxzx119.com/zxzx.apk'
        }
      }
    }
  },
  mounted () {
    // window.onorientationchange = this.origin()
    // console.log(111)
    var ua = window.navigator.userAgent.toLowerCase()
    var browser = {
      versions: (function () {
        var u = navigator.userAgent

        // eslint-disable-next-line no-unused-vars
        var app = navigator.appVersion
        return {
          trident: u.indexOf('Trident') > -1, // IE
          presto: u.indexOf('Presto') > -1, // opera
          webKit: u.indexOf('AppleWebKit') > -1, //
          gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, //
          mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios
          android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android
          iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, // iPhone
          iPad: u.indexOf('iPad') > -1, // iPad
          webApp: u.indexOf('Safari') === -1 // web
        }
      }()),
      language: (navigator.browserLanguage || navigator.language).toLowerCase()
    }

    if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
      console.log('ios')
      window.location = 'https://itunes.apple.com/cn/app/id1301911560?mt=8'
    } else if (browser.versions.android) {
      console.log('android')
      // console.log(ua.match(/MicroMessenger/i))
      let matcher = ua.match(/MicroMessenger/i)
      console.log(matcher)
      if (matcher !== null && matcher.indexOf('micromessenger') > -1) {
        this.weixinFlag = true
      } else {
        window.location = 'http://cdn.zxzx119.com/zxzx.apk'
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.body {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: url("../assets/downbg.jpg") no-repeat center center;
  background-size: 100% 100%;
  z-index: 5;
  .topmasker {
    position: relative;
    // height: 90px;
    width: 100%;
    position: fixed;
    z-index: 10;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    text-align: center;
    .box {
      margin: 9.5px auto 0 auto;
      text-align: left;
      display: inline-block;
    }
    .head {
      font-size: 12px;
      color: #ffffff;
      margin-bottom: 13px;
    }
    .detail {
      line-height: 15px;
      font-size: 12px;
      color: #ffffff;
      margin-bottom: 8px;
      .icon1 {
        margin: 0 3px 0 4px;
        width: 15px;
        height: 15px;
        display: inline-block;
        background: url("../assets/maskmore.png") no-repeat center center;
        background-size: cover;
        vertical-align: top;
      }
      .icon1::after {
        content: "";
        position: absolute;
        width: 120px;
        height: 35px;
        background: url("../assets/maskarrow.png") no-repeat center center;
        background-size: cover;
        top: 15px;
        right: 20px;
      }
      span {
        background: #ffffff;
        text-align: center;
        margin-left: 3.5px;
        display: inline-block;
        width: 111px;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: #333333;
        border-radius: 10px;
        .icon2 {
          display: inline-block;
          width: 12px;
          height: 12px;
          margin-right: 5.5px;
          background: url("../assets/maskweb.png") no-repeat center center;
          background-size: cover;
          vertical-align: text-top;
          margin-top: 2px;
        }
      }
    }
    .detail:last-child {
      margin-bottom: 13px;
    }
  }
  .toplogo {
    width: 72px;
    height: 72px;
    text-align: center;
    margin: 50px auto 14px auto;
    background: url("../assets/downlogo.png") no-repeat center center;
    background-size: 100% 100%;
  }
  .topTitle {
    text-align: center;
    font-size: 24px;
    color: #ffffff;
    margin-bottom: 7px;
    font-weight: bold;
  }
  .toptext {
    text-align: center;
    font-size: 15px;
    color: #ffffff;
    margin-bottom: 28.5px;
  }
  .btn {
    position: relative;
    z-index: 500;
    text-align: center;
    height: 40px;
    margin-bottom: 30px;
    .text {
      line-height: 38px;
      display: inline-block;
      width: 135px;
      height: 40px;
      font-size: 15px;
      color: #ffffff;
      border-radius: 20px;
      background: linear-gradient(-90deg, #ff8932 0%, #e13022 100%);
      // background: #ff8832;
    }
  }
  .iphone {
    // position: fixed;
    width: 4.7rem;
    height: 9.6rem;
    margin: 0 auto;
    background: url("../assets/downiphone.png") no-repeat center center;
    background-size: 100% auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Qrcode.vue